import { render, staticRenderFns } from "./TickerAdminEditRecQuick.vue?vue&type=template&id=45996bb9"
import script from "./TickerAdminEditRecQuick.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditRecQuick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports